export const graphqlErrorMessages = {
  NotAuthorized: 'Not Authorized',
  Login: 'Please log in to continue',
  InternalServerError: 'Internal Server Error',
  InvalidArguments: 'Invalid Arguments',
  CSRFTokenError: 'CSRF Token Mismatch',
};
